import { STORAGE_KEYS } from "@/lib/storage-keys";
import { markPageUnloading } from "@/services/api";

/**
 * « Revenir sur la bonne voie » — reconnexion propre proposée à l'utilisateur quand un
 * écran reste en erreur après un réessai.
 *
 * Vide l'état de session potentiellement corrompu puis repart de la racine (`/` →
 * `RootRedirect`, qui réoriente selon le rôle). `replace` plutôt que `href` : on n'empile
 * pas la page en erreur dans l'historique, le bouton « précédent » n'y ramène pas.
 *
 * Ne ferme pas l'onglet : un script ne peut pas fermer un onglet qu'il n'a pas ouvert
 * (blocage navigateur). La consigne « ferme puis rouvre l'onglet » reste affichée en repli.
 *
 * ⚠️ On préserve `_imp` et `auth-storage` : en mode impersonation le token vit dans
 * `sessionStorage` (cf. `auth.store.ts`), un `clear()` aveugle déconnecterait l'admin.
 */
export function revenirSurLaBonneVoie(): void {
  try {
    const preserved = new Map<string, string>();
    for (const key of [STORAGE_KEYS.IMPERSONATION_FLAG, STORAGE_KEYS.AUTH_STORAGE]) {
      const value = sessionStorage.getItem(key);
      if (value !== null) preserved.set(key, value);
    }

    sessionStorage.clear();

    for (const [key, value] of preserved) {
      sessionStorage.setItem(key, value);
    }
  } catch {
    // Stockage indisponible (mode privé strict, quota) : on recharge quand même.
  }

  // Départ volontaire : les requêtes en vol vont être annulées, ne pas les compter comme incidents.
  markPageUnloading();
  window.location.replace("/");
}
